import { render, staticRenderFns } from "./beneficiary-details.vue?vue&type=template&id=0475fd0c&"
import script from "./beneficiary-details.vue?vue&type=script&lang=js&"
export * from "./beneficiary-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports